import { Stack } from '@mui/material';
import React from 'react';

import { SyncStatus } from '@/console/features/devices/components/sync-status/sync-status';
import { GroupSyncStatusTooltip } from '@/console/features/groups/components/group-sync-status/group-sync-status-tooltip/group-sync-status-tooltip';
import { TGroupSyncStatusProps } from '@/console/features/groups/components/group-sync-status/group-sync-status.types';
import { DeviceSyncStatusEnum } from '@/shared/types/types.generated';

export const GroupSyncStatus: React.FC<TGroupSyncStatusProps> = ({
  deviceInformation,
  status,
  icon,
}) => {
  const getSyncStatusTooltip = () => {
    if (
      !deviceInformation?.length ||
      !status ||
      status === DeviceSyncStatusEnum.Unknown
    ) {
      return null;
    }

    return (
      <Stack gap="0.5rem">
        {deviceInformation?.map(
          ({ deviceName, deviceId, syncStatusTimestamp, syncStatus }) => (
            <GroupSyncStatusTooltip
              key={deviceId}
              assetId={deviceId}
              syncStatusTimestamp={syncStatusTimestamp}
              assetName={deviceName}
              status={deviceInformation?.length > 1 ? syncStatus : undefined}
              navigateToAssetPath={(id) => `/devices/${id}`}
            />
          ),
        )}
      </Stack>
    );
  };

  return (
    <SyncStatus tooltip={getSyncStatusTooltip()} status={status} icon={icon} />
  );
};
